import { useQueryWithErrorBoundary, useSupabaseTypedClient } from 'hooks/reactQuery';

import { TanstackQueryName } from 'types/frontend';

import { UserCV } from '../types';

export const useGetCVsQuery = (userId: string | undefined) => {
  const supabase = useSupabaseTypedClient();

  const { data, isFetching, refetch } = useQueryWithErrorBoundary({
    queryKey: [TanstackQueryName.GetCVs, userId],
    queryFn: async () => {
      if (!userId) return [];

      const { data, error } = await supabase
        .from('user_cv')
        .select('*')
        .eq('user_id', userId)
        .order('updated_at', { ascending: false });

      if (error) throw error;

      return data as unknown as UserCV[];
    },
    enabled: Boolean(userId),
  });

  return {
    cvs: data || [],
    isFetching,
    refetch,
  };
};
